import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { ComponentBase, T4InvoiceInfo, T4CCService, OrderCustomerModel, ProductInfo } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';

@Component({
  styleUrls: ['./Invoices.css'],
  selector: 't4-invoices',
  templateUrl: './Invoices.component.html',
})
export class InvoicesComponent extends ComponentBase implements OnInit {
  @ViewChild("tblInvoices") private tblInvoices: T4DatatableWidget;
  @Input() customerId: string = "";
  public isCustomerSpecific: boolean = false;
  public isLoading: boolean = false;
  public invoices: T4InvoiceInfo[] = [];
  public filteredInvoices: T4InvoiceInfo[] = [];
  public activeCustomers: OrderCustomerModel[] = [];
  public filteredCustomers: OrderCustomerModel[] = [];
  public selectedCustomer: string = null;
  public searchText: string = '';
  public products: ProductInfo[] = [];
  public filteredProducts: ProductInfo[] = [];
  public selectedProduct: string = null;
  public searchProductText: string = '';
  constructor(private ccService: T4CCService) {
    super();
  }

  private _from: moment.Moment = this.now.clone().startOf("month").add(-11, 'month');
  private _to: moment.Moment = this.now.clone().endOf("month");
  public queryParameters: any = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };

  public get from(): moment.Moment { return this._from; }
  public set from(val: moment.Moment) {
    if (this._from != val) {
      this._from = val;
      this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };
    }
  }

  public get to(): moment.Moment { return this._to; }
  public set to(val: moment.Moment) {
    if (this._to != val) {
      this._to = val;
      this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };
    }
  }

  public updateParams() {
    this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };
    this.loadData();
  }

  async ngOnInit() {
    if (this.customerId != null && this.customerId != "") {
      this.isCustomerSpecific = true;
    }
    await this.loadData();
    this.products = await this.Api.get<ProductInfo[]>("CC/GetProducts");
    this.filteredProducts = this.products;    
  }

  private async loadData() {    
    this.isLoading = true;
    if (this.customerId != null && this.customerId != "") {
      this.invoices = await this.Api.get<T4InvoiceInfo[]>("CC/GetInvoicesForCustomer", { customerId: this.customerId, from: this.from, to: this.to });
      this.filteredInvoices = this.invoices;
    }
    else {
      this.invoices = await this.Api.get<T4InvoiceInfo[]>("CC/GetInvoices", { from: this.from, to: this.to });
      this.activeCustomers = await this.Api.get<OrderCustomerModel[]>("/TurboOrder/GetCustomers", { onlyActive: true });
      this.filteredCustomers = this.activeCustomers;
      this.filteredInvoices = this.invoices;
      this.selectedCustomer = null;
    }

    this.selectedProduct = null;
    this.isLoading = false;
  }

  public async resend(invoice: T4InvoiceInfo) {
    if (invoice.SalesId || invoice.IsProcessing) {
      if (!(await this.UI.confirm("TO.Invoices.headConfirmResend", "Confirm resend", "TO.Invoices.msgConfirmResend", "This order either failed to send to Annata or pending for processing. Make sure you do not end up with duplicates. Continue?"))) return;
    }

    if (this.ccService.Resend(invoice.Id))
      this.UI.snackBar("The invoice has been resent. Expected import time: ~10 minutes.", null, 10000);
    else
      this.UI.snackBar("The invoice could not be resent!", null, 10000);
  }

  public open(id: string) {
    this.UI.openDialog("T4.Order.InvoiceDialog", { maxHeight: "calc(100vh - 20px)", maxWidth: "calc(100vw - 20px)", width: "800px", data: { invoiceId: id } });
  }

  public filterCustomers() {
    this.filteredCustomers = this.activeCustomers.filter(customer => customer.Name.toLowerCase().includes(this.searchText.toLowerCase()) || customer.InvoiceAccount.toLowerCase().includes(this.searchText.toLowerCase()));
  }

  public resetSearch(opened: boolean) {
    if (!opened) {
      this.searchText = '';
      this.filteredCustomers = this.activeCustomers;
    }
  }

  public async onCustomerChange(value: string) {
    this.selectedCustomer = value;
    await this.updateFilter(false);
  }

  public filterProducts() {
    this.filteredProducts = this.products.filter(product => product.Name.toLowerCase().includes(this.searchProductText.toLowerCase()));
  }

  public resetProductSearch(opened: boolean) {
    if (!opened) {
      this.searchProductText = '';
      this.filteredProducts = this.products;
    }
  }

  public async onProductChange(value: string) {
    this.selectedProduct = value;
    await this.updateFilter(true);
  }

  private async updateFilter(isProduct: boolean) {
    if (isProduct) {
      this.filteredInvoices = this.selectedProduct == null || this.selectedProduct == '0' ? this.invoices : this.invoices.filter(x => x.InvoiceProductList.includes(this.selectedProduct));
    }
    else {
      this.filteredInvoices = this.selectedCustomer == null || this.selectedCustomer == '0' ? this.invoices : this.invoices.filter(x => x.InvoiceAccount == this.selectedCustomer);
    }
    
    this.tblInvoices.update();
  }
}
